import {
  branch_category_overall_v4,
  branch_category_cluster_v4,
  branch_category_area_v4,
  branch_category_branch_v4,
} from "../../v4-services/reports/branch_category_service";
import { actionTypes } from "../action_types";

const getBranchCategory = (fetchFunction, type) => (data) => (dispatch) => {
  return fetchFunction(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type,
        payload: resp.data !== null ? resp.data : { branchCategories: [] },
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetBranchCategoryOverallV4 = getBranchCategory(
  branch_category_overall_v4,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_OVERALL
);

export const GetBranchCategoryClusterV4 = getBranchCategory(
  branch_category_cluster_v4,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_CLUSTER
);

export const GetBranchCategoryAreaV4 = getBranchCategory(
  branch_category_area_v4,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_AREA
);

export const GetBranchCategoryBranchV4 = getBranchCategory(
  branch_category_branch_v4,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_BRANCH
);
